import { useState } from "react";
import { container } from "tsyringe";
import Button, { EButtonVariant } from "components/elements/Button";
import Typography, { ITypo } from "components/elements/Typography";
import I18n from "components/materials/I18n";
import ClientService from "services/ClientService";
import classes from "./classes.module.scss";
import ClientSheetAdminCreateMinimalRequestResource from "common/resources/ClientSheet/ClientSheetAdminCreateMinimalRequestResource";
import { ValidationError } from "common/resources/Resource";
import Form from "components/materials/Form";
import InputElement, { EInputType } from "components/materials/Form/InputElement";

interface ICreateMinimalClientPPProps {
	creatorId: string;
	onClientCreated: (clientSheetId: string) => void;
	onCancel: () => void;
}

const clientService = container.resolve(ClientService);

export default function CreateMinimalClientPP({ creatorId, onClientCreated, onCancel }: ICreateMinimalClientPPProps) {
	const [loading, setLoading] = useState(false);
	const [errors, setErrors] = useState<ValidationError[]>([]);

	const handleSubmit = async (_e: React.FormEvent<HTMLFormElement>, formData: { [key: string]: unknown }) => {
		setErrors([]);
		setLoading(true);

		try {
			const resource = ClientSheetAdminCreateMinimalRequestResource.hydrate<ClientSheetAdminCreateMinimalRequestResource>({
				firstName: formData["firstName"] as string,
				lastName: formData["lastName"] as string,
			});
			await resource.validateOrReject();
			const clientSheet = await clientService.createMinimalByAdmin(resource, creatorId);
			onClientCreated(clientSheet.id);
		} catch (err) {
			if (err instanceof Array) {
				setErrors(err);
			} else {
				setErrors([{ property: "form", constraints: { error: "La fiche n’a pas pu être créée. Votre saisie est conservée. Réessayez ou contactez le support." } }]);
			}
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className={classes["container"]}>
			<Typography typo={ITypo.H2} className={classes["title"]}>
				{I18n.asset.pages.mo_manual_subscription.create_minimal_client_pp_title}
			</Typography>

			<Typography typo={ITypo.P_MEDIUM_BOLD} className={classes["description"]}>
				{I18n.asset.pages.mo_manual_subscription.create_minimal_client_pp_description}
			</Typography>

			<Form onSubmit={handleSubmit} className={classes["form"]} errors={errors}>
				<InputElement label="Prénom *" placeholder="Prénom du client" name="firstName" type={EInputType.TEXT} />
				<InputElement label="Nom *" placeholder="Nom du client" name="lastName" type={EInputType.TEXT} />

				<div className={classes["actions"]}>
					<Button variant={EButtonVariant.OUTLINED} onClick={onCancel} disabled={loading}>
						Annuler
					</Button>
					<Button variant={EButtonVariant.CONTAINED} type="submit" disabled={loading}>
						{loading ? "Création..." : "Créer le client"}
					</Button>
				</div>
			</Form>
		</div>
	);
}
